import type { GModalDeleteInitialValues } from '../types';

import { useGModalContext, ModalType } from '~/presentation/ui';
import { useState } from 'react';

interface UseGModalDeleteProps {
  onSuccess?: (data: GModalDeleteInitialValues) => Promise<void>;
}

export const useGModalDelete = (params?: UseGModalDeleteProps) => {
  const { onOpenModal, initialValues, onCloseModal } = useGModalContext<ModalType.DELETE>();
  const [isLoading, setIsLoading] = useState(false);

  const handleOpenDeleteModal = (data: GModalDeleteInitialValues) => {
    onOpenModal(ModalType.DELETE, data);
  };

  const handleDelete = async () => {
    if (!initialValues) {
      throw new Error('initialValues is required');
    }

    setIsLoading(true);
    try {
      await params?.onSuccess?.(initialValues);
    } finally {
      setIsLoading(false);
      onCloseModal();
    }
  };

  return {
    isLoading,
    initialValues,
    handleDelete,
    handleOpenDeleteModal,
  };
};
